export enum NotificationTargetAudience {
	AllUsers = 'all_users',
	UsersWithTrades = 'users_with_trades',
	UsersWithZeroTrades = 'users_with_zero_trades',
	ZeroLlmBots = 'users_with_zero_llm_bots',
}
